import { Link, NavLink, useNavigate } from "react-router-dom";
import { Radio, Clapperboard, LayoutDashboard, ShieldCheck, LogOut, Plus, UserRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function navItems(user) {
  const items = [
    { to: "/", label: "Curtas", icon: Clapperboard, testid: "nav-shorts" },
    { to: "/lives", label: "Lives", icon: Radio, testid: "nav-feed" },
  ];
  if (user.role !== "user") items.push({ to: "/painel", label: "Painel", icon: LayoutDashboard, testid: "institution-dashboard-link" });
  if (user.is_super_admin) items.push({ to: "/super-admin", label: "Admin", icon: ShieldCheck, testid: "nav-admin" });
  items.push({ to: `/perfil/${user.id}`, label: "Perfil", icon: UserRound, testid: "nav-profile" });
  return items;
}

const itemCls = ({ isActive }) => `flex flex-col items-center gap-0.5 px-2 py-1 text-[11px] font-semibold ${isActive ? "text-[hsl(var(--gold))]" : "text-muted-foreground"}`;

export function BottomNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const items = navItems(user);
  const doLogout = async () => {
    await logout();
    navigate("/entrar");
  };
  const NavItem = (i) => (
    <NavLink key={i.to} to={i.to} end className={itemCls} data-testid={`mobile-${i.testid}`}>
      <i.icon size={20} /> {i.label}
    </NavLink>
  );
  return (
    <nav className="glass fixed bottom-0 inset-x-0 z-40 border-t border-white/5 md:hidden" data-testid="bottom-nav">
      <div className="flex items-center justify-around py-2">
        {items.slice(0, 2).map(NavItem)}
        <Link to="/gravar" className="grid h-11 w-14 place-items-center rounded-2xl bg-[hsl(var(--gold))] text-[#0B0F17] shadow-lg shadow-amber-500/30 transition-transform active:scale-90" data-testid="nav-record-button" aria-label="Gravar vídeo curto">
          <Plus size={24} strokeWidth={3} />
        </Link>
        {items.slice(2).map(NavItem)}
        <button onClick={doLogout} className="flex flex-col items-center gap-0.5 px-2 py-1 text-[11px] font-semibold text-muted-foreground" data-testid="mobile-logout-button">
          <LogOut size={20} /> Sair
        </button>
      </div>
    </nav>
  );
}
